module.exports = __webpack_public_path__ + "img/ico-change.bcf2905b.svg";